import React from "react";

const Input = ({
  handleChange,
  name,
  value,
  type,
  id,
  autoComplete,
  placeholder,
  direction,
  errorHandler,
  center,
}) => {
  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: direction,

          justifyContent: center ? "center" : "",
          alignItems: center ? "center" : "",
        }}
      >
        <label htmlFor={id}>{id.charAt(0).toUpperCase() + id.slice(1)}</label>
        <input
          type={type}
          value={value}
          name={name}
          id={id}
          onChange={handleChange}
          autoComplete={autoComplete}
          className="input"
        />
        {errorHandler && (
          <p
            style={{
              height: "20px",

              marginBottom: "10px",
              color: "red",
            }}
            htmlFor={name}
          >
            {placeholder}
          </p>
        )}
      </div>
    </>
  );
};

export default Input;
